import { EventEmitter, Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { EnvironmentService } from './environment.service';
import { isNullOrUndefined } from '../utils/utils';
import {
  ApolloClient,
  HttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client/core';
import { Observable, of } from 'rxjs';
import { setContext } from '@apollo/client/link/context';

@Injectable({
  providedIn: 'root',
})
export class AppsyncService {
  private _auth = inject(AuthService);
  private _env = inject(EnvironmentService);

  client!: ApolloClient<NormalizedCacheObject>;
  cache = new InMemoryCache();
  clientHydratedEvent = new EventEmitter<any>();

  constructor() {
    this.configure();
  }

  async configure() {
    const url = this._env.getGraphQLURL();

    // Create a dynamic auth link to handle token refresh correctly
    const authLink = setContext(async (_, { headers }) => {
      const token = await this._auth.getJWT();

      return {
        headers: {
          ...headers,
          Authorization: token ? `Bearer ${token}` : '',
        },
      };
    });

    const httpLink = new HttpLink({ uri: url });

    this.client = new ApolloClient({
      link: authLink.concat(httpLink),
      cache: this.cache,
    });

    this.clientHydratedEvent.emit();
  }

  gqlClient(): Observable<ApolloClient<NormalizedCacheObject>> {
    return of(this.client);
  }

  isClientConfigured(): boolean {
    return !isNullOrUndefined(this.client);
  }
}
